// extracted by mini-css-extract-plugin
module.exports = {"body":"clinical-portal-3__Layout__body","hasHeader":"clinical-portal-3__Layout__hasHeader","main":"clinical-portal-3__Layout__main"};